import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';

var _templateObject;
var IframeRolexStyled = styled.iframe(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  height: 80px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  overflow: inherit;\n  @media (min-width: 992px) {\n    display: ", ";\n  }\n  @media (max-width: 991.98px) {\n    height: 70px;\n    display: ", ";\n  }\n"])), function (props) {
  return props.mobile ? "100%" : "200px";
}, function (props) {
  return !props.mobile ? "block" : "none";
}, function (props) {
  return props.mobile ? "block" : "none";
});
var MOBILE_SRC = "https://static.rolex.com/clocks/2021/pga_org_mobile_HTML_320x70/rolex.html";
var DESKTOP_SRC = "https://static.rolex.com/clocks/2021/pga_org_desk_HTML_200x80/rolex.html";
var getSrc = function getSrc(mobile) {
  return mobile ? MOBILE_SRC : DESKTOP_SRC;
};
var index = (function (_ref) {
  var mobile = _ref.mobile;
  return /*#__PURE__*/React__default.createElement(IframeRolexStyled, {
    src: getSrc(mobile),
    mobile: mobile
  });
});

export { DESKTOP_SRC, IframeRolexStyled, MOBILE_SRC, index as default };
